import { render, staticRenderFns } from "./logs-list.vue?vue&type=template&id=785be083&scoped=true&"
import script from "./logs-list.vue?vue&type=script&lang=js&"
export * from "./logs-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785be083",
  null
  
)

export default component.exports